<template>
  <CModal v-if="inModal" class="h-[100vh] w-[100vw]" show :trap-focus="false" @keydown.esc="closeApp">
    <slot />
  </CModal>

  <slot v-else />
</template>

<script setup lang="ts">
import CModal from '@lib/components/CModal/CModal.vue'
import { useAppStore } from '@collection-player/stores/app.store'

const { closeApp, inModal } = useAppStore()
</script>
